import(/* webpackMode: "eager" */ "/vercel/path0/src/app/services/page.tsx");
